<template>
    <div>
        <form-row>
            <form-cell width="half">
                <suggest-field
                    :label="$t('forms.referrals.make.fields.patient_first_name.label')"
                    :placeholder="$t('forms.referrals.make.fields.patient_first_name.placeholder')"
                    :suggestionsCall="patientSuggestionsCall"
                    :isRequired="true"
                    :isDisabled="isDisabled"
                    :isSuggested="isSuggested"
                    :formData="formData"
                    :formPrefills="formPrefills"
                    valuePath="patient.firstName"
                    @change="change($event)"
                    @select="changePatientData($event)"
                    @hoverSuggestion="prefillPatientData($event)"
                ></suggest-field>
            </form-cell>

            <form-cell width="half">
                <suggest-field
                    :label="$t('forms.referrals.make.fields.patient_last_name.label')"
                    :placeholder="$t('forms.referrals.make.fields.patient_last_name.placeholder')"
                    :suggestionsCall="patientSuggestionsCall"
                    :isSuggested="isSuggested"
                    :isRequired="true"
                    :isDisabled="isDisabled"
                    :formData="formData"
                    :formPrefills="formPrefills"
                    valuePath="patient.lastName"
                    @change="change($event)"
                    @hoverSuggestion="prefillPatientData($event)"
                    @select="changePatientData($event)"
                ></suggest-field>
            </form-cell>

            <form-cell width="quarter">
                <text-field
                    :label="$t('forms.referrals.make.fields.patient_ssn.label')"
                    :placeholder="$t('forms.referrals.make.fields.patient_ssn.placeholder')"
                    :isRequired="true"
                    :isDisabled="isDisabled"
                    :isSuggested="isSuggested"
                    :formData="formData"
                    :formPrefills="formPrefills"
                    valuePath="patient.ssn"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row align="stretch">
            <form-cell width="half">
                <birth-date-field
                    :label="$t('forms.referrals.make.fields.patient_birth_date.label')"
                    :isSuggested="isSuggested"
                    :isRequired="true"
                    :isDisabled="isDisabled"
                    :formData="formData"
                    :formPrefills="formPrefills"
                    valuePath="patient.dateOfBirth"
                    @change="change($event)"
                ></birth-date-field>
            </form-cell>

            <form-cell width="half">
                <phone-field
                    :label="$t('forms.referrals.make.fields.patient_mobile_phone.label')"
                    :placeholder="$t('common.phone_number.placeholder')"
                    :hint="$t('forms.referrals.make.fields.patient_mobile_phone.info')"
                    :isRequired="true"
                    :isSuggested="isSuggested"
                    :isDisabled="isDisabled"
                    :formData="formData"
                    :formPrefills="formPrefills"
                    valuePath="patient.mobilePhone"
                    @change="change($event)"
                    @country-code-change="emitEvent({ name: 'country-code-change', payload: $event })"
                ></phone-field>
            </form-cell>
        </form-row>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import FormFragmentMixin from 'mixins/FormFragmentMixin'
    import FormChangeableMixin from 'mixins/FormChangeableMixin'
    import PracticesAPI from 'api/PracticesAPI'
    import { composeDisplayName } from 'components/common/CommonUserName'

    export default {
        mixins: [FormFragmentMixin, FormChangeableMixin],

        props: {
            practiceId: { type: [String, Number], default: 0 },
        },

        data() {
            return {
                formPrefills: {},
                isSuggested: false,
            }
        },

        computed: {
            patientSuggestionsCall() {
                return (query) => {
                    return PracticesAPI.getPatients(this.practiceId ?? 0, query).then((patient) =>
                        patient.map((patient) => ({
                            label: this.$t('forms.referrals.make.fields.patient_first_name.born_on', {
                                name: composeDisplayName(patient),
                                date: dayjs(patient.dateOfBirth).format('MMM DD YYYY'),
                            }),
                            value: patient,
                        })),
                    )
                }
            },
        },

        methods: {
            changePatientData({ value: patient } = {}) {
                if (!patient) {
                    return
                }

                this.change({
                    path: 'patient',
                    value: patient,
                })

                this.change({
                    path: 'patientId',
                    value: patient.id,
                })

                this.isSuggested = true
            },

            prefillPatientData({ value: patient } = {}) {
                this.formPrefills = { patient }
            },
        },

        mounted() {
            this.$on('local:beforeChange', (path) => {
                if (path === 'patient') {
                    return
                }

                this.isSuggested = false
            })
        },
    }
</script>
